import * as form from '../form';

export const foreignBusinessVentures = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        Name: form.name(xitem.Name),
        Address: form.location(xitem.Address),
        Citizenship: form.country(xitem.Citizenship),
        Description: form.textarea(xitem.Description),
        Relationship: form.textarea(xitem.Relationship),
        Dates: form.daterange(xitem.Dates),
        Association: form.textarea(xitem.Association),
        Position: form.text(xitem.Position),
        Service: form.text(xitem.Service),
        Support: form.text(xitem.Support),
        Compensation: form.textarea(xitem.Compensation),
        AddressNotApplicable: form.notapplicable(xitem.AddressNotApplicable), // PVQ Only
        InUsaNotApplicable: form.notapplicable(xitem.InUsaNotApplicable), // PVQ Only
        CitizenshipNotApplicable: form.notapplicable(xitem.CitizenshipNotApplicable), // PVQ Only
        RelationshipPvq: form.radio(xitem.RelationshipPvq), // PVQ Only
        RelationshipOtherExplanation: form.textarea(xitem.RelationshipOtherExplanation), // PVQ Only
        Role: form.radio(xitem.Role), // PVQ Only
        RoleOtherExplanation: form.textarea(xitem.RoleOtherExplanation), // PVQ Only
        FinancialSupportEstimated: form.checkbox(xitem.FinancialSupportEstimated), // PVQ Only
      },
    };
  });
  return {
    HasForeignVentures: form.branch(data.HasForeignVentures),
    List: form.collection(items, (data.List || {}).branch),
  };
};
